
import {
  Scene,
  WebGLRenderer,
  PerspectiveCamera,
  ShaderMaterial,
  Mesh,
  Color,
  Clock,
  SphereGeometry,
  MeshBasicMaterial,
  Vector3,
  Object3D,
  Float32BufferAttribute,
  Group,
  IcosahedronGeometry,
  AdditiveBlending,
  Vector2,
  BackSide,
  AudioListener,
  Audio,
  AudioLoader,
  AudioAnalyser
} from 'three'

import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { MeshSurfaceSampler } from 'three/examples/jsm/math/MeshSurfaceSampler'

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass'
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass'
import { AfterimagePass } from 'three/examples/jsm/postprocessing/AfterimagePass'

import { InstancedUniformsMesh } from 'three-instanced-uniforms-mesh'

import { Pane } from 'tweakpane'
import { gsap } from 'gsap'

class App {
  constructor(container) {
    this.container = document.querySelector(container)

    this.config = {
      backgroundColor: new Color('#0d021f'),
      cameraSpeed: 0,
      cameraRadius: 4.5,
      particlesSpeed: 0,
      particlesCount: 3000,
      bloomStrength: 1.45,
      bloomThreshold: 0.34,
      bloomRadius: 0.5
    }

    this.tick = 0

    this._resizeCb = () => this._onResize()
  }

  init() {
    this._createScene()
    this._createCamera()
    this._createRenderer()
    this._createPostprocess()
    this._createMainGroup()
    this._createIcosahedron()
    this._createBigSphere()
    this._createSphere()
    this._createSampler()
    this._createParticles()
    this._createClock()
    this._addListeners()
    this._createControls()
    this._createDebugPanel()

    this.renderer.setAnimationLoop(() => {
      this._update()
      this._render()
    })

    const audioBtn = document.querySelector('#audio-btn')
    audioBtn
      .addEventListener('click', () => {
        const tl = new gsap.timeline({
          onComplete: () => {
            this._loadMusic()
          }
        })

        tl
          .set('#audio-btn-icon', { transition: 'none' })
          .to('#audio-btn-label', { '--clip': 1, duration: 0.6 })
          .to('#audio-btn-icon', { rotation: 140, scale: 0.8, duration: 0.5 }, '<0.05')
          .to('#audio-btn-icon', { opacity: 0, duration: 0.65 }, '<')
          .to(audioBtn, { height: 66, width: 66, ease: 'back.inOut(2)', duration: 0.9}, '<0.2')

          .set('#credits', { display: 'block' })
      })
      
      // below for eventdetails
      const eventBtn = document.querySelector('#eventbtn');
      eventBtn
        .addEventListener('click', () => {
          const tla = new gsap.timeline({
          })
   
          tla
            .set('#credits', { transition: 'none' })
            .to('#creditscontent', { '--clip': 1, duration: 0.6 })
            .set('.eventp', { display: 'none' })
            .to('#credits-icon', { rotation: 140, scale: 0.8, duration: 0.5 }, '<0.05')
            .to('#credits-icon', { opacity: 0, duration: 0.65 }, '<')
            .to('#credits', { height: 66, width: 66, ease: 'back.inOut(2)', duration: 0.9}, '<0.2')
            .set('#eventdetails', { display: 'block' }) 
            .to('#eventdetails', { height: '84%', width: '40em', maxWidth: '96%', ease: 'back.inOut(2)', duration: 0.9}, '<0.2') 
            .to('#eventdetails-icon', { opacity: 1, duration: 0.65 }, '<')
            .to('#eventdetails-icon', { rotation: 360, scale: 1, duration: 0.5 }, '<0.05')
            .set('#eventcontent', { display: 'block' }) 
            .to('#eventcontent', { '--clip': -1, duration: 0.6 })
            .set('#eventp', { display: 'block' }) 
        })
        
        
        // below for get linup btn in mainmenu
        const lineupBtn = document.querySelector('#getlineupbtn')
      lineupBtn
        .addEventListener('click', () => {
          const tlaa = new gsap.timeline({
          })
   
          tlaa
            .set('#credits', { transition: 'none' })
            .to('#creditscontent', { '--clip': 1, duration: 0.6 })
            .to('#credits-icon', { rotation: 140, scale: 0.8, duration: 0.5 }, '<0.05')
            .to('#credits-icon', { opacity: 0, duration: 0.65 }, '<')
            .to('#credits', { height: 66, width: 66, ease: 'back.inOut(2)', duration: 0.9}, '<0.2')
            .set('#lineup', { display: 'block' }) 
            .to('#lineup', { height: '84%', width: '40em', maxWidth: '96%', ease: 'back.inOut(2)', duration: 0.9}, '<0.2') 
            .to('#lineup-icon', { opacity: 1, duration: 0.65 }, '<')
            .to('#lineup-icon', { rotation: 360, scale: 1, duration: 0.5 }, '<0.05')
            .set('#lineupcontent', { display: 'block' }) 
            .to('#lineupcontent', { '--clip': -1, duration: 0.6 })
        })
   
        // below for get linup btn in event menu
        const lineupBtn2 = document.querySelector('#lineuplink')
        lineupBtn2
          .addEventListener('click', () => {
       
            const tlaaa = new gsap.timeline({
            })
   
            tlaaa
              .set('#eventdetails', { transition: 'none' })
              .to('#eventcontent', { '--clip': 1, duration: 0.6 })
              .to('#eventdetails-icon', { rotation: 140, scale: 0.8, duration: 0.5 }, '<0.05')
              .to('#eventdetails-icon', { opacity: 0, duration: 0.65 }, '<')
              .to('#eventdetails', { height: 66, width: 66, ease: 'back.inOut(2)', duration: 0.9}, '<0.2')
              .set('#eventdetails', { display: 'none' }) 
              .set('#lineup', { display: 'block' }) 
              .to('#lineup', { height: '84%', width: '40em', maxWidth: '96%', ease: 'back.inOut(2)', duration: 0.9}, '<0.2') 
              .to('#lineup-icon', { opacity: 1, duration: 0.65 }, '<')
              .to('#lineup-icon', { rotation: 360, scale: 1, duration: 0.5 }, '<0.05')
              .set('#lineupcontent', { display: 'block' }) 
              .to('#lineupcontent', { '--clip': -1, duration: 0.6 })
          })
   
          // below for eventmenulink details info
          const eventMenuBtn0 = document.querySelector('#detailslink')
          eventMenuBtn0
            .addEventListener('click', () => {
              const activeEl0 = document.querySelector('.active');
              activeEl0.classList.remove("active")
              eventMenuBtn0.classList.add("active")
              const tlb0 = new gsap.timeline({
              })
      
              tlb0
              .set('.eventp', { transition: 'none' })
              .set('.eventp', { display: 'none' })
              .set('#eventp', { width: '65%', ease: 'back.inOut(2)', duration: 0.9}, '<0.2') 
              .set('#eventp', { display: 'block' }) 
            })
   
            // below for eventmenulink ticket info
            const eventMenuBtn = document.querySelector('#ticketslink')
            eventMenuBtn
              .addEventListener('click', () => {
                const activeEl = document.querySelector('.active');
                activeEl.classList.remove("active")
                eventMenuBtn.classList.add("active")
                const tlb = new gsap.timeline({
                })
        
                tlb
                .set('.eventp', { transition: 'none' })
                .set('.eventp', { display: 'none' })
                .set('#eventp0', { width: '65%', ease: 'back.inOut(2)', duration: 0.9}, '<0.2') 
                .set('#eventp0', { display: 'block' }) 
              })
   
            // below for eventmenulink rules info
            const eventMenuBtn20 = document.querySelector('#ruleslink')
            eventMenuBtn20
              .addEventListener('click', () => {
                const activeEl20 = document.querySelector('.active');
                activeEl20.classList.remove("active")
                eventMenuBtn20.classList.add("active")
                const tlc0 = new gsap.timeline({
                })
        
                tlc0
                .set('.eventp', { transition: 'none' })
                .set('.eventp', { display: 'none' })
                .set('#eventp11', { width: '65%', ease: 'back.inOut(2)', duration: 0.9}, '<0.2') 
                .set('#eventp11', { display: 'block' }) 
              })
   
             // below for eventmenulink amenity info
             const eventMenuBtn2 = document.querySelector('#amenitieslink')
             eventMenuBtn2
               .addEventListener('click', () => {
                 const activeEl2 = document.querySelector('.active');
                 activeEl2.classList.remove("active")
                 eventMenuBtn2.classList.add("active")
                 const tlc = new gsap.timeline({
                 })
   
                 tlc
                 .set('.eventp', { transition: 'none' })
                 .set('.eventp', { display: 'none' })
                 .set('#eventp1', { width: '65%', ease: 'back.inOut(2)', duration: 0.9}, '<0.2') 
                 .set('#eventp1', { display: 'block' }) 
               })
   
   
            // below for eventmenulink tips info
            const eventMenuBtn3 = document.querySelector('#tipslink')
            eventMenuBtn3
              .addEventListener('click', () => {
                const activeEl3 = document.querySelector('.active');
                activeEl3.classList.remove("active")
                eventMenuBtn3.classList.add("active")
                const tld = new gsap.timeline({
                })
        
                tld
                .set('.eventp', { transition: 'none' })
                .set('.eventp', { display: 'none' })
                .set('#eventp2', { width: '65%', ease: 'back.inOut(2)', duration: 0.9}, '<0.2') 
                .set('#eventp2', { display: 'block' }) 
              })
   
                // below for eventmenulink itinerary info
                const eventMenuBtn5 = document.querySelector('#intinerarylink')  
                eventMenuBtn5
                  .addEventListener('click', () => {
                    const activeEl5 = document.querySelector('.active');
                    activeEl5.classList.remove("active")
                    eventMenuBtn5.classList.add("active")
                    const tlf = new gsap.timeline({
                    })
            
                    tlf
                    .set('.eventp', { transition: 'none' })
                    .set('.eventp', { display: 'none' })
                    .set('#eventp4', { width: '65%', ease: 'back.inOut(2)', duration: 0.9}, '<0.2') 
                    .set('#eventp4', { display: 'block' }) 
                  })
   
                  // below for eventmenulink joinus info
                  const eventMenuBtn6 = document.querySelector('#joinuslink')  
                  eventMenuBtn6
                    .addEventListener('click', () => {
                      const activeEl6 = document.querySelector('.active');
                      activeEl6.classList.remove("active")
                      eventMenuBtn6.classList.add("active")
                      const tlf = new gsap.timeline({
                      })
              
                      tlf
                      .set('.eventp', { transition: 'none' })
                      .set('.eventp', { display: 'none' })
                      .set('#eventp5', { width: '65%', ease: 'back.inOut(2)', duration: 0.9}, '<0.2') 
                      .set('#eventp5', { display: 'block' }) 
                    })
   
                   
              // below to close eventdetails
              const mainmenubtn = document.querySelector('#mainmenulink')
              mainmenubtn
                .addEventListener('click', () => {
                  const tlg = new gsap.timeline({
                  })
          
                  tlg
                    .set('#eventdetails', { transition: 'none' })
                    .to('#eventcontent', { '--clip': 1, duration: 0.6 })
                    .to('#eventdetails-icon', { rotation: 140, scale: 0.8, duration: 0.5 }, '<0.05')
                    .to('#eventdetails-icon', { opacity: 0, duration: 0.65 }, '<')
                    .to('#eventdetails', { height: 66, width: 66, ease: 'back.inOut(2)', duration: 0.9}, '<0.2')
                    .set('#eventdetails', { display: 'none' }) 
                    .set('#credits', { display: 'block' })
                    .to('#credits', { height: screen.availHeight/2, width: screen.availWidth, ease: 'back.inOut(2)', duration: 0.9}, '<0.2') 
                    .to('#credits-icon', { opacity: 1, duration: 0.65 }, '<')
                    .to('#credits-icon', { rotation: 360, scale: 1, duration: 0.5 }, '<0.05')
                    .set('#creditscontent', { display: 'block' }) 
                    .to('#creditscontent', { '--clip': -1, duration: 0.6 })
                })
          
    
                // below to close lineup
              const mainmenubtn2 = document.querySelector('#mainmenulink2')
              mainmenubtn2
                .addEventListener('click', () => {
                  const tlh = new gsap.timeline({
                  })
          
                  tlh
                    .set('#lineup', { transition: 'none' })
                    .to('#lineupcontent', { '--clip': 1, duration: 0.6 })
                    .to('#lineup-icon', { rotation: 140, scale: 0.8, duration: 0.5 }, '<0.05')
                    .to('#lineup-icon', { opacity: 0, duration: 0.65 }, '<')
                    .to('#lineup', { height: 66, width: 66, ease: 'back.inOut(2)', duration: 0.9}, '<0.2')
                    .set('#lineup', { display: 'none' }) 
                    .set('#credits', { display: 'block' })
                    .to('#credits', { height: screen.availHeight/2, width: screen.availWidth, ease: 'back.inOut(2)', duration: 0.9}, '<0.2') 
                    .to('#credits-icon', { opacity: 1, duration: 0.65 }, '<')
                    .to('#credits-icon', { rotation: 360, scale: 1, duration: 0.5 }, '<0.05')
                    .set('#creditscontent', { display: 'block' }) 
                    .to('#creditscontent', { '--clip': -1, duration: 0.6 })
                })



                  // below for lineupmenulink Full Lineup 
                  const lineupMenuBtna1 = document.querySelector('#link0')
                  lineupMenuBtna1
                    .addEventListener('click', () => {
                      const activeElaa1 = document.querySelector('.active');
                      activeElaa1.classList.remove("active")
                      lineupMenuBtna1.classList.add("active")
                      const tlbba1 = new gsap.timeline({
                      })
              
                      tlbba1
                      .set('.lineupp', { transition: 'none' })
                      .set('.lineupp', { display: 'none' })
                      .set('#lineupp01', { width: '65%', ease: 'back.inOut(2)', duration: 0.9}, '<0.2') 
                      .set('#lineupp01', { display: 'block' }) 
                    })

                    // below for lineupmenulink Vendor Lineup 
              const lineupMenuBtna2 = document.querySelector('#link1')
              lineupMenuBtna2
                .addEventListener('click', () => {
                  const activeElaa2 = document.querySelector('.active');
                  activeElaa2.classList.remove("active")
                  lineupMenuBtna2.classList.add("active")
                  const tlbba2 = new gsap.timeline({
                  })
          
                  tlbba2
                  .set('.lineupp', { transition: 'none' })
                  .set('.lineupp', { display: 'none' })
                  .set('#lineupp02', { width: '65%', ease: 'back.inOut(2)', duration: 0.9}, '<0.2') 
                  .set('#lineupp02', { display: 'block' }) 
                })
   
                  // below for lineupmenulink Friday September 8th 2023
            const lineupMenuBtn = document.querySelector('#frilink')
            lineupMenuBtn
              .addEventListener('click', () => {
                const activeEla = document.querySelector('.active');
                activeEla.classList.remove("active")
                lineupMenuBtn.classList.add("active")
                const tlbb = new gsap.timeline({
                })
        
                tlbb
                .set('.lineupp', { transition: 'none' })
                .set('.lineupp', { display: 'none' })
                .set('#lineupp', { width: '65%', ease: 'back.inOut(2)', duration: 0.9}, '<0.2') 
                .set('#lineupp', { display: 'block' }) 
              })
   
            
   
            // below for lineupmenulink 2022 recap
            const lineupMenuBtn3 = document.querySelector('#recaplink')
            lineupMenuBtn3
              .addEventListener('click', () => {
                const activeEl3a = document.querySelector('.active');
                activeEl3a.classList.remove("active")
                lineupMenuBtn3.classList.add("active")
                const tldd = new gsap.timeline({
                })
        
                tldd
                .set('.lineupp', { transition: 'none' })
                .set('.lineupp', { display: 'none' })
                .set('#lineup2', { width: '65%', ease: 'back.inOut(2)', duration: 0.9}, '<0.2') 
                .set('#lineup2', { display: 'block' }) 
              })
           }

  destroy() {
    this.renderer.dispose()
    this._removeListeners()
  }

  _update() {
    const elapsed = this.clock.getElapsedTime()

    this.mainGroup.rotation.y += 0.002
    this.mainGroup.rotation.z += 0.0012

    this.icosahedron.rotation.x += 0.009

    this.bigSphere.rotation.z -= 0.003
    this.bigSphere.rotation.y -= 0.001

    this.particles.material.uniforms.uTime.value += 0.05*this.config.particlesSpeed

    this.bigSphere.material.uniforms.uTime.value = elapsed

    if (!!this.analyser) {
      const d = this.analyser.getFrequencyData()

      const o = d.reduce((prev, curr) => prev + curr, 0)

      this.particles.material.uniforms.uInfluence.value = o / d.length * 0.03

      this.icosahedron.scale.setScalar(1 - o / d.length * 0.006)

      this.tick += 0.01
      this.camera.position.x = Math.sin(this.tick*0.63)*2.7*this.config.cameraSpeed
      this.camera.position.y = Math.sin(this.tick*0.84)*2.15*this.config.cameraSpeed
      this.camera.position.z = Math.cos(this.tick*0.39)*this.config.cameraRadius*this.config.cameraSpeed
      this.camera.lookAt(this.scene.position)
    }
  }

  _render() {
    this.composer.render()
  }

  _createScene() {
    this.scene = new Scene()
  }

  _createCamera() {
    this.camera = new PerspectiveCamera(75, this.container.clientWidth / this.container.clientHeight, 0.1, 100)
    this.camera.position.set(0, 0, this.config.cameraRadius)
  }

  _createRenderer() {
    this.renderer = new WebGLRenderer({
      alpha: true,
      antialias: true
    })

    this.container.appendChild(this.renderer.domElement)

    this.renderer.setSize(this.container.clientWidth, this.container.clientHeight)
    this.renderer.setPixelRatio(Math.min(1.5, window.devicePixelRatio))
    this.renderer.setClearColor(this.config.backgroundColor)
  }

  _createPostprocess() {
    this.renderPass = new RenderPass(this.scene, this.camera)

    const resolution = new Vector2(this.container.clientWidth, this.container.clientHeight)

    this.bloomPass = new UnrealBloomPass(resolution, 0, 0, 0)
    this.bloomPass.threshold = this.config.bloomThreshold
    this.bloomPass.strength = this.config.bloomStrength
    this.bloomPass.radius = this.config.bloomRadius

    this.afterimagePass = new AfterimagePass()
    this.afterimagePass.uniforms.damp.value = 0.6

    this.composer = new EffectComposer(this.renderer)
    this.composer.addPass(this.renderPass)
    this.composer.addPass(this.afterimagePass)
    this.composer.addPass(this.bloomPass)
  }

  _createControls() {
    if (process.env.NODE_ENV === 'production') return
    this.controls = new OrbitControls(this.camera, this.renderer.domElement)
  }

  _createMainGroup() {
    this.mainGroup = new Group()
    this.scene.add(this.mainGroup)
  }

  _createSphere() {
    const geom = new SphereGeometry(2, 32, 16)

    const mat = new MeshBasicMaterial({
      color: 0xffffff,
      wireframe: true,
      opacity: 0.1,
      transparent: true
    })

    this.sphere = new Mesh(geom, mat)
  }

  _createBigSphere() {
    const material = new ShaderMaterial({
      fragmentShader: require('./shaders/background.fragment.glsl'),
      vertexShader: require('./shaders/background.vertex.glsl'),
      side: BackSide,
      wireframe: true,
      transparent: true,
      opacity: 0.1,
      uniforms: {
        uTime: { value: 0 }
      }
    })

    const geom = new SphereGeometry(6.5, 120, 60)

    this.bigSphere = new Mesh(geom, material)

    this.scene.add(this.bigSphere)
  }

  _createSampler() {
    this.sampler = new MeshSurfaceSampler(this.sphere).build()
  }

  _createParticles() {
    const geom = new SphereGeometry(0.01, 16, 16)

    const material = new ShaderMaterial({
      vertexShader: require('./shaders/particle.vertex.glsl'),
      fragmentShader: require('./shaders/particle.fragment.glsl'),
      transparent: true,
      blending: AdditiveBlending,
      uniforms: {
        uTime: { value: 1 },
        uDirection: { value: new Vector3() },
        uRandom: { value: 0 },
        uInfluence: { value: 0 }
      }
    })

    this.particles = new InstancedUniformsMesh(geom, material, this.config.particlesCount)

    const tempPosition = new Vector3()
    const tempObject = new Object3D()
    const center = new Vector3()

    const directions = []

    for (let i = 0; i < this.config.particlesCount; i++) {
      this.sampler.sample(tempPosition)
      tempObject.position.copy(tempPosition)
      tempObject.scale.setScalar(0.5 + Math.random()*0.5)
      tempObject.updateMatrix()
      this.particles.setMatrixAt(i, tempObject.matrix)

      // Set direction of the particle
      const dir = new Vector3()
      dir.subVectors(tempPosition, center).normalize()
      this.particles.setUniformAt('uDirection', i, dir)
      this.particles.setUniformAt('uRandom', i, Math.random())
    }

    geom.setAttribute('aDirection', new Float32BufferAttribute(directions, 3))
    geom.attributes.aDirection.needsUpdate = true

    this.mainGroup.add(this.particles)
  }

  _createIcosahedron() {
    const geom = new IcosahedronGeometry(1.2, 0)
    const mat = new MeshBasicMaterial({
      color: 0xffffff,
      wireframe: true,
      transparent: true,
      opacity: 0.5
    })

    this.icosahedron = new Mesh(geom, mat)

    this.mainGroup.add(this.icosahedron)
  }

  _createDebugPanel() {
    //this.pane = new Pane()

    /**
     * Scene configuration
     */
    // const sceneFolder = this.pane.addFolder({ title: 'Scene' })

    // sceneFolder.addInput(this.config, 'backgroundColor', { label: 'Background Color' }).on('change', e => {
    //   this.renderer.setClearColor(new Color(e.value.r, e.value.g, e.value.b))
    // })

    // sceneFolder.addInput(this.particles.material.uniforms.uInfluence, 'value', { label: 'Influence', min: 0, max: 1 })
    // sceneFolder.addInput(this.config, 'particlesSpeed', { label: 'Speed', min: 0, max: 1 })

    /**
     * Bloom
     */
    // const bloomFolder = this.pane.addFolder({ title: 'Bloom effect Options', expanded: false })

    // bloomFolder.addInput(this.bloomPass, 'enabled', { label: 'Enabled' })
    // bloomFolder.addInput(this.bloomPass, 'strength', { label: 'Strength', min: 0, max: 3 })
    // bloomFolder.addInput(this.bloomPass, 'threshold', { label: 'Threshold', min: 0, max: 1 })
    // bloomFolder.addInput(this.bloomPass, 'radius', { label: 'Radius', min: 0, max: 1 })

    /**
     * Afterimage
     */
    // const afterimageFolder = this.pane.addFolder({ title: 'Afterimage effect options', expanded: false })

    // afterimageFolder.addInput(this.afterimagePass, 'enabled', { label: 'Enabled' })
    // afterimageFolder.addInput(this.afterimagePass.uniforms.damp, 'value', { label: 'Damp', min: 0, max: 1 })
  }

  _loadMusic() {
    return new Promise(resolve => {
      const listener = new AudioListener()
      this.camera.add(listener)

      this.music = new Audio(listener)
      this.scene.add(this.music)

      const loader = new AudioLoader()
      let value3 = Math.floor(Math.random() * 10);
      let newsong;
      if(value3 == 4 || value3 == 1 || value3 == 9){
        newsong = '/Woodkey-Festival-2023-Champagne-Drip-ENERGY-HEALING.mp3';
      } else if(value3 == 2 || value3 == 8 || value3 == 7){
        newsong = '/Woodkey-Festival-2023-Sully-EAR-CANDY.mp3';
      } else if(value3 == 3 || value3 == 6){
        newsong = '/Woodkey-Festival-2023-Sully-Mount-Everest-Remix.mp3';
      } else {
        newsong = '/Woodkey-Festival-2023-Sully-Back-It-Up-vip.mp3';
      }
      loader.load('/Woodkey-Festival-2023-Sully-EAR-CANDY.mp3', buffer => {
        const tl = new gsap.timeline({
          onComplete: () => {
            this.music.setBuffer(buffer)
            this.music.setLoop(true)
            this.music.setVolume(0.1)

            this.analyser = new AudioAnalyser(this.music, 128)

            gsap.delayedCall(0.3, () => this.music.play())

            resolve()
          }
        })

        tl
          .add('start')
          .to('#audio-btn', {
            scale: 0,
            duration: 0.6,
            ease: 'back.in(2)'
          })
          .to('#audio-btn', { autoAlpha: 0, duration: 0.65 }, 'start+=0.3')

          .to(this.config, {
            particlesSpeed: 0.55,
            cameraSpeed: 1,
            duration: 1.3
          }, 'start')
      }, progress => {
        gsap.to('#audio-btn-loader', {
          '--scale': () => progress.loaded / progress.total,
          duration: 0.15,
          overwrite: true,
          ease: 'power1.out'
        })
      })
    })
  }

  _createClock() {
    this.clock = new Clock()
  }

  _addListeners() {
    window.addEventListener('resize', this._resizeCb, { passive: true })
  }

  _removeListeners() {
    window.removeEventListener('resize', this._resizeCb, { passive: true })
  }

  _onResize() {
    this.camera.aspect = this.container.clientWidth / this.container.clientHeight
    this.camera.updateProjectionMatrix()

    this.renderer.setSize(this.container.clientWidth, this.container.clientHeight)
    this.composer.setSize(this.container.clientWidth, this.container.clientHeight)
  }
}

const app = new App('#app')
app.init()